import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login");
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data?.token) localStorage.setItem("ashra_token", data.token);
        setUser(data.user);
        // Clear hash
        window.history.replaceState({}, document.title, "/dashboard");
        nav("/dashboard", { replace: true });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300 grid place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 rounded-full border-2 border-violet-500 border-t-transparent animate-spin" />
        <p className="mt-4 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
